export const REQUEST_GET_MAPPING_LAWYERS = 'REQUEST_GET_MAPPING_LAWYERS';
export const REQUEST_SET_MAPPING_LAWYERS = 'REQUEST_SET_MAPPING_LAWYERS';
export const REQUEST_CREATE_INTERVENANT_KEYCLOAK =
  'REQUEST_CREATE_INTERVENANT_KEYCLOAK';
export const REQUEST_UPDATE_MAPPING_LAWYERS = 'REQUEST_UPDATE_MAPPING_LAWYERS';
export const REQUEST_SEARCH_MAPPING_LAWYERS = 'REQUEST_SEARCH_MAPPING_LAWYERS';
export const REQUEST_GET_MAPPING_LAWYER = 'REQUEST_GET_MAPPING_LAWYER';
export const REQUEST_SET_MAPPING_LAWYER = 'REQUEST_SET_MAPPING_LAWYER';
export const SEARCH_TYPE_IDS = {
  LAWYER: 'LAWYER',
  JURISDICTION: 'JURISDICTION',
};

export const SEARCH_QUERY_INIT_VALUES = {
  jurisdictionId: null,
  lawyerCode: null,
};
